module.exports = __webpack_public_path__ + "static/media/recharge.1f727374.svg";